<template>
  <div :class="[$style.wrapper, { [$style.inactive]: !isActive }]">
    <div :class="[$style.shopName, { [$style.inactiveText]: !isActive }]">
      <div>
        <VdIcon
          v-if="isShopDefault"
          v-tooltip="'Default shop'"
          store="fas"
          name="star"
          color="var(--vd-color-blue-default)"
        />
        {{ shopName }}
      </div>
      <div>
        <span :class="$style.shopId">{{ shopId }}</span>
        <CopyButton :id="shopId" style="margin-left: 0.25rem" @click.stop />
      </div>
    </div>
    <div :class="$style.shopAction">
      <ShopDropdownMenu
        :can-user-edit="isEditable"
        :is-shop-default="isShopDefault"
        @set-shop-as-default="setShopAsDefault"
        @delete-shop="handleDeleteShop"
        @duplicate-shop="handleDuplicateShop"
        @edit-shop="handleEditShop"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";

import CopyButton from "@/components/CopyButton/CopyButton.vue";
import VdIcon from "@/components/VdIcon/VdIcon.vue";
import useShopsManager from "../hooks/useShopsManager";
import ShopDropdownMenu from "./ShopDropdownMenu.vue";

const props = defineProps({
  shopName: {
    type: String,
    default: "Default shop",
  },
  shopId: {
    type: String,
    required: true,
  },
  isActive: {
    type: Boolean,
    default: true,
  },
  isShopDefault: {
    type: Boolean,
    default: false,
  },
  isEditable: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();
const versionId = route.params.versionId as string;
const appId = route.params.gameId as string;

const { deleteShop, duplicateShop } = useShopsManager(appId, versionId);

const emits = defineEmits(["set-shop-as-default", "edit-shop"]);

const setShopAsDefault = () => {
  emits("set-shop-as-default");
};

const handleDeleteShop = async () => {
  await deleteShop(props.shopId);
};

const handleEditShop = async () => {
  emits("edit-shop");
};

const handleDuplicateShop = async () => {
  await duplicateShop(props.shopId);
};
</script>

<style module>
.wrapper {
  display: flex;
  justify-content: space-between;
  background-color: var(--vd-color-white);
  border-bottom: var(--vd-base-primary-color) 2px solid;
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.2);
  padding: 0.5rem 1rem;
  min-width: 200px;
  transition: background-color 0.3s, color 0.3s, border 0.3s;
  cursor: pointer;
}

.shopName {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.inactive {
  background-color: var(--vd-color-neutral-light-10);
  border-bottom: none;
}

.inactiveText {
  color: var(--vd-color-text-light-2);
}

.options {
  cursor: pointer;
}
.shopAction {
  margin-left: 0.5rem;
  margin-top: 0.15rem;
}

.shopId {
  font-size: 0.75rem;
  color: var(--vd-color-grey-light-1);
}
</style>
